<template>
  <div class="relative">
    <div v-if="is_loading" class="loading"></div>
    <div
      class="skill_box is-flex is-align-items-center is-justify-content-center"
      :class="{ 'is-loading': is_loading }"
    >
      <button class="button is-danger mx-1" @click="deleteSkill">X</button>
      <div class="is-flex is-align-items-center">
        <p class="m-0 mx-1">{{ position_skill.skill.name }}</p>
        <p class="m-0">({{ minExperience }})</p>
      </div>
      <div class="is-flex">
        <button class="button is-info mx-1" @click="increase">+</button>
        <button class="button is-info mx-1" @click="decrease">-</button>
      </div>
      <button :class="toggleClass" @click="toggle">#</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'position-skill',
  props: {
    position_id: {
      type: Number,
      required: true
    },
    company_id: {
      type: Number,
      required: true
    },
    position_skill: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      is_loading: false
    }
  },
  computed: {
    minExperience () {
      return this.position_skill.min_experience || 0
    },
    toggleClass () {
      return `button is-info is-outlined mx-1 ${this.position_skill.is_tagged ? 'is-revoked' : ''}`
    }
  },
  methods: {
    toggle () {
      this.serverCall('updatePositionSkill', 'toggle', {
        is_tagged: !this.position_skill.is_tagged
      })
    },
    increase () {
      this.serverCall('updatePositionSkill', 'increase', {
        min_experience: this.minExperience + 1
      })
    },
    decrease () {
      this.serverCall('updatePositionSkill', 'decrease', {
        min_experience: this.minExperience > 0 ? this.minExperience - 1 : this.minExperience
      })
    },
    deleteSkill () {
      this.serverCall('deletePositionSkill')
    },
    async serverCall (method, action, params) {
      this.is_loading = true
      await this.$network_utils[method]({
        id: this.position_skill.id,
        position_id: this.position_id,
        current_company_id: this.company_id,
        ...params
      })
      await this.$network_utils.updatePosition({ position_id: this.position_id, active_at: new Date() })
      this.$emit('refresh', { action, skill: this.position_skill })
      this.is_loading = false
    }
  }
}
</script>
<style scoped>
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.is-loading {
  pointer-events: none;
  opacity: 0.5;
}
</style>
